import { themeColours } from "../../resources";
import "./HomePageGuide.css";
import { IoMdInformationCircleOutline } from "react-icons/io";
import { InfoModal } from "./InfoModal";
import { useStateObject } from "../../hooks/useStateObject";
const resultPage = require("../../assets/cartPage.png");

export function CartPageGuide() {
  const [iconChecks, setIconChecks] = useStateObject<{ [key: string]: boolean }>({});
  return (
    <div className="homePageContainer">
      <img src={resultPage} alt="background" className="background" />
      <InfoModal
        element={
          <span className="cartEditIcon">
            <IoMdInformationCircleOutline
              size={20}
              color={iconChecks["edit"] ? themeColours.secondary : themeColours.green}
            />
          </span>
        }
        heading={"Item Edit"}
        texts={[
          <h5 className="modalInfo">
            Click here to edit the item. You can either change the <strong className="extraBold">quantity</strong> of
            items, <strong className="extraBold">remove</strong> the item or find an{" "}
            <strong className="extraBold">alternative</strong> - this takes you back to the shop screen where you can
            choose a <strong className="extraBold">different</strong> item or{" "}
            <strong className="extraBold">adjust</strong> the search criteria.
          </h5>,
        ]}
        onOpenClick={() => setIconChecks({ edit: true })}
      />
      <InfoModal
        element={
          <span className="savingsIcon">
            <IoMdInformationCircleOutline
              size={20}
              color={iconChecks["saving"] ? themeColours.secondary : themeColours.green}
            />
          </span>
        }
        heading={"Cart Savings"}
        texts={[
          <h5 className="modalInfo">
            The savings achieved for the <strong className="extraBold">entire</strong> cart. Click to see the savings
            for each item. The savings are based on the <strong className="extraBold">value</strong> for the specific
            item chosen compared to the <strong className="extraBold">average value</strong> for items that meet the
            search criteria.
          </h5>,
          <h5 className="modalInfo">
            Each item savings is calculated by taking it's <strong className="extraBold">value savings</strong> per unit
            from the search criteria and then <strong className="extraBold">multiplying</strong> it by the number of
            units in that product (to make up it's volume), and finally the{" "}
            <strong className="extraBold">quantity</strong> of that product in the cart.
          </h5>,
          <h5 className="modalInfo">
            Items that were added from a <strong className="extraBold">specific search</strong> do not achieve a savings
            amount if there is only one product that is returned in the result - as is the case in this tutorial.
          </h5>,
        ]}
        onOpenClick={() => setIconChecks({ saving: true })}
      />
      <InfoModal
        element={
          <span className="valueItemIcon">
            <IoMdInformationCircleOutline
              size={20}
              color={iconChecks["valueItem"] ? themeColours.secondary : themeColours.green}
            />
          </span>
        }
        heading={"Value Items"}
        texts={[
          <h5 className="modalInfo">
            This indicates the number of <strong className="extraBold">best value</strong> items that were selected
            during the shop.
          </h5>,
        ]}
        onOpenClick={() => setIconChecks({ valueItem: true })}
      />
      <InfoModal
        element={
          <span className="cancelShopIcon">
            <IoMdInformationCircleOutline
              size={20}
              color={iconChecks["cancel"] ? themeColours.secondary : themeColours.green}
            />
          </span>
        }
        heading={"Cancel Shop"}
        texts={[
          <h5 className="modalInfo">
            Cancelling your shop will <strong className="extraBold">clear</strong> you cart and allow you to start a{" "}
            <strong className="extraBold">new</strong> one on the home page.
          </h5>,
        ]}
        onOpenClick={() => setIconChecks({ cancel: true })}
      />
      <InfoModal
        element={
          <span className="completeShopIcon">
            <IoMdInformationCircleOutline
              size={20}
              color={iconChecks["complete"] ? themeColours.secondary : themeColours.green}
            />
          </span>
        }
        heading={"Complete Shop"}
        texts={[
          <h5 className="modalInfo">
            Completing the shop will <strong className="extraBold">record</strong> it under your recent shops and allow
            you to save the cart as a <strong className="extraBold">template</strong> for future shops.
          </h5>,
        ]}
        onOpenClick={() => setIconChecks({ complete: true })}
      />
    </div>
  );
}
